<!-- /////////////////////////////////////////////////////////////////////////// TEMPLATE -->

<template>
    <div class="lsn-form__wrapper" :class="{ 'lsn-form__wrapper--error': error }">

        <!-- Label -->
        <label v-if="label || hasLabelSlot" class="lsn-form__label" @click="focus">
            <slot name="label">
                {{ label }}
                <span v-if="required" class="lsn-form_label--required">*</span>
            </slot>
        </label>

        <!-- Input -->
        <input
            ref="input"
            type="text"
            class="lsn-form__input"
            :name="name || null"
            :tabindex="tabindex"
            :value="modelValue"
            :placeholder="placeholder"
            :minlength="minlength"
            :maxlength="maxlength"
            :disabled="disabled"
            :autocomplete="autocomplete"
            @input="change"
        />

        <!-- Error -->
        <div v-if="error" class="lsn-form__error">
            {{ errMsg }}
        </div>
    </div>
</template>


<!-- /////////////////////////////////////////////////////////////////////////// SCRIPT -->

<script>
export default
{
    name: 'LsnInput',

    props:
    {
        modelValue:
        {
            type:    [String, Number],
            default: null,
        },
        label:
        {
            type:    String,
            default: null,
        },
        placeholder:
        {
            type:    String,
            default: '',
        },
        minlength:
        {
            type:    Number,
            default: null,
        },
        maxlength:
        {
            type:    Number,
            default: null,
        },
        disabled:
        {
            type:    Boolean,
            default: false,
        },
        error:
        {
            type:    [String, Array],
            default: null,
        },
        tabindex:
        {
            type:    Number,
            default: null,
        },
        required:
        {
            type:    Boolean,
            default: false,
        },
        autocomplete:
        {
            type:    String,
            default: 'on',
        },
        name:
        {
            type:    String,
            default: '',
        },
    },

    emits: ['update:modelValue'],

    computed:
    {
        hasLabelSlot()
        {
            return !!this.$slots.label;
        },

        errMsg()
        {
            return Array.isArray(this.error) ? this.error[0] : this.error;
        },
    },

    methods:
    {
        change(event)
        {
            this.$emit('update:modelValue', event.target.value);
        },

        focus()
        {
            this.$nextTick(() =>
            {
                this.$refs.input.focus();
            });
        },
    },
};
</script>


<!-- /////////////////////////////////////////////////////////////////////////// STYLE -->

<style lang="scss" scoped>
</style>
